import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { View, type Pretty, type Typed, DLightViewProp, required } from "@dlightjs/dlight";
import { RouteGroupEnv, RouteOption, RouteProps } from "./types";
class Route extends View implements RouteProps {
  constructor() {
    super();
    this.collectRoutes = this.collectRoutes.bind(this);
  }
  $e$_dl_router_routesCollect;
  _dl_router_routesCollect: RouteGroupEnv["_dl_router_routesCollect"] = required;
  $$_dl_router_routesCollect = 1;
  $s$_dl_router_routesCollect = ["collectRoutes"];
  $p$path;
  _$contentKey = "path";
  path: RouteProps["path"] = (".*" as RouteProps["path"]);
  $$path = 2;
  $s$path = ["collectRoutes"];
  $p$comp;
  comp?: RouteProps["comp"];
  $$comp = 4;
  $s$comp = ["collectRoutes"];
  get children() {
    return this._$children;
  }
  $p$loading;
  loading?: RouteProps["loading"];
  $$loading = 8;
  $s$loading = ["collectRoutes"];
  $p$redirect;
  redirect?: RouteProps["redirect"];
  $$redirect = 16;
  $s$redirect = ["collectRoutes"];
  $p$info;
  info?: RouteOption["info"];
  $$info = 32;
  $s$info = ["collectRoutes"];
  $w$collectRoutes;
  collectRoutes() {
    if (this._$cache("collectRoutes", [this._dl_router_routesCollect, this.path, this.comp, this.loading, this.redirect, this.info])) {
      return;
    }
    this._dl_router_routesCollect!(this.path!, {
      comp: this.comp,
      children: this.children,
      loading: this.loading,
      redirect: this.redirect,
      info: this.info
    });
  }
}
export default ((Route as Pretty) as Typed<RouteProps>);